import { keyBy } from "lodash";
import { FloSingleSelect } from "../../../../components/flo-select/flo-single-select";
import { JobAppAddressInformationRequest } from "../../../api-docs";
import { FieldSet } from "@/components/utils/useFieldSet";
import { TextInput } from "@/flokit/compound/inputs/text-input/text-input";

const COUNTRY_OPTIONS = [
  // TODO: Once we have a country list we can add it here
  {
    label: "United States",
    value: "United States",
  },
  {
    label: "Canada",
    value: "Canada",
  },
  {
    label: "United Kingdom",
    value: "United Kingdom",
  },
];

const COUNTRY_OPTIONS_MAP = keyBy(COUNTRY_OPTIONS, "value");

export const AddressInfoFragment = (
  props: FieldSet<JobAppAddressInformationRequest> & {
    addressLineOneRequired?: boolean;
    addressLineTwoRequired?: boolean;
    cityRequired?: boolean;
    stateRequired?: boolean;
    zipCodeRequired?: boolean;
    countryRequired?: boolean;
    isInModal?: boolean;

    onChange: (
      value: string,
      field: keyof JobAppAddressInformationRequest,
    ) => void;
  },
) => {
  return (
    <div className="grid gap-x-6 gap-y-5 pb-4 sm:grid-cols-2">
      <TextInput
        label="Address Line 1"
        name="addressLineOne"
        onChange={(v) => props.onChange(v, "addressLineOne")}
        value={props.values.addressLineOne}
        isRequired={props.addressLineOneRequired}
        validationMessage={props.validationMsg.addressLineOne}
        shouldShowValidation={props.validation.addressLineOne}
        onBlur={props.onBlur("addressLineOne")}
      />
      <TextInput
        label="Address Line 2"
        name="addressLineTwo"
        onChange={(v) => props.onChange(v, "addressLineTwo")}
        value={props.values.addressLineTwo}
        isRequired={props.addressLineTwoRequired}
        validationMessage={props.validationMsg.addressLineTwo}
        shouldShowValidation={props.validation.addressLineTwo}
        onBlur={props.onBlur("addressLineTwo")}
      />

      <TextInput
        label="City"
        name="city"
        onChange={(v) => props.onChange(v, "city")}
        value={props.values.city}
        isRequired={props.cityRequired}
        validationMessage={props.validationMsg.city}
        shouldShowValidation={props.validation.city}
        onBlur={props.onBlur("city")}
      />

      <TextInput
        label="State"
        name="state"
        onChange={(v) => props.onChange(v, "state")}
        value={props.values.state}
        isRequired={props.stateRequired}
        validationMessage={props.validationMsg.state}
        shouldShowValidation={props.validation.state}
        onBlur={props.onBlur("state")}
      />

      <TextInput
        label="Zip Code"
        name="zipCode"
        onChange={(v) => props.onChange(v, "zipCode")}
        value={props.values.zipCode}
        isRequired={props.zipCodeRequired}
        validationMessage={props.validationMsg.zipCode}
        shouldShowValidation={props.validation.zipCode}
        onBlur={props.onBlur("zipCode")}
      />

      <FloSingleSelect
        name="country"
        label="Country"
        onChange={(v) => props.onChange(v?.value ?? null, "country")}
        options={COUNTRY_OPTIONS}
        value={COUNTRY_OPTIONS_MAP[props.values.country] ?? null}
        required={props.countryRequired}
        validationMessage={props.validationMsg.country}
        shouldShowValidation={props.validation.country}
        onBlur={props.onBlur("country")}
        isInModal={props.isInModal}
      />
    </div>
  );
};
